module.exports = __webpack_public_path__ + "media/images/salespartner/salespartner01-dad812ec54938cc4f42abe1bfd4a1bf8.svg";